import React, { useCallback, useEffect, useRef, useState } from 'react';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import { Message, Actions } from './ConfirmDialog.styles';

// Diálogo de confirmación con el estilo de la marca (reemplaza window.confirm).
const ConfirmDialog = ({
  title,
  message,
  confirmLabel = 'Aceptar',
  cancelLabel = 'Cancelar',
  danger = false,
  onConfirm,
  onCancel,
}) => (
  <Modal title={title} onClose={onCancel} maxWidth="440px" labelledBy="confirm-title">
    <Message>{typeof message === 'string' ? <p>{message}</p> : message}</Message>
    <Actions>
      <Button type="button" variant="ghost" onClick={onCancel}>{cancelLabel}</Button>
      <Button type="button" variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Actions>
  </Modal>
);

// Hook: `const { confirm, dialog } = useConfirm()`. Renderiza `{dialog}` en el
// componente y usa `await confirm({ title, message, confirmLabel, ... })`, que
// resuelve true/false como lo haría window.confirm.
export const useConfirm = () => {
  const [options, setOptions] = useState(null);
  const resolver = useRef(null);

  const settle = useCallback((value) => {
    if (resolver.current) resolver.current(value);
    resolver.current = null;
    setOptions(null);
  }, []);

  const confirm = useCallback((opts) => new Promise((resolve) => {
    // Si ya había uno abierto, se descarta (false) antes de abrir el nuevo.
    if (resolver.current) resolver.current(false);
    resolver.current = resolve;
    setOptions(opts);
  }), []);

  // Si el componente se desmonta con el diálogo abierto, la promesa no se queda colgada.
  useEffect(() => () => {
    if (resolver.current) resolver.current(false);
    resolver.current = null;
  }, []);

  const dialog = options ? (
    <ConfirmDialog
      {...options}
      onConfirm={() => settle(true)}
      onCancel={() => settle(false)}
    />
  ) : null;

  return { confirm, dialog };
};

export default ConfirmDialog;
